import type { EditorSDK } from '@wix/wix-data-client-common-standalone'

export const runTransactionWithRetry = async <T>(
  editorSdkProxy: EditorSDK,
  transaction: () => T,
  retriesLeft = 1,
): Promise<T> => {
  let lastErrorInTransaction
  const transactionWithHandler = async () => {
    try {
      return await transaction()
    } catch (error) {
      lastErrorInTransaction = error
      throw error
    }
  }

  try {
    return await editorSdkProxy.document.transactions.runAndWaitForApproval(
      transactionWithHandler,
    )
  } catch (error: any) {
    const isConflictError =
      await editorSdkProxy.document.transactions.isConflictError(error)
    if (retriesLeft > 0 && isConflictError) {
      return runTransactionWithRetry(
        editorSdkProxy,
        transaction,
        retriesLeft - 1,
      )
    } else {
      throw new Error('EditorSDK transaction failed', {
        cause: lastErrorInTransaction || error,
      })
    }
  }
}
